import Request from '../Request.utils'
export interface IDbChatRequestBody {
  client?: string;
  filterLocations?: string[];
  postingDateFrom: string;
  postingDateTo: string;
  question: string;
}
export interface ILogRequestBody {
  client: string;
  email: string;
  isBotResponse: boolean;
  message: any;
}


class AssistantAPI {
  copilot = async () => {
    const res = await Request.call('/api/ai-assisstant/copilot', 'POST', undefined, undefined, undefined, );
    return res;
  }
  chat = async () => {
    const res = await Request.call('/api/ai-assisstant/chat', 'POST', undefined, undefined, undefined, );
    return res;
  }
  dbChat = async (body: IDbChatRequestBody) => {
    const res = await Request.call('/api/ai-assisstant/db-chat', 'POST', undefined, undefined, body, );
    return res;
  }
  log = async (body: ILogRequestBody) => {
    const res = await Request.call('/api/ai-assisstant/log', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new AssistantAPI()